export function safeSetLocalStorage(key: string, value: any): void {
  try {
    localStorage.setItem(key, value);
  } catch (error) {
    console.warn(error);
  }
}

export function safeRemoveLocalStorage(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.warn(error);
  }
}

export function safeLocalStorageGet(key: string) {
  try {
    return localStorage.getItem(key);
  } catch {
    return undefined;
  }
}

export function safeGetLocalStorageJson(
  key: string
): Record<string, any> | null {
  try {
    const value = localStorage.getItem(key);
    if (value) {
      return JSON.parse(value);
    }
  } catch (error) {
    // do nothing
  }
  return null;
}
